export function firstDayNextMonthLastYear() {
    const today = new Date();
    return new Date((new Date(Date.UTC(today.getUTCFullYear() - 1, today.getUTCMonth() + 1, 1)).setUTCHours(0, 0, 0, 0)))
        .toISOString()
        .replace('.000Z', '');
}

export function lastDayThisMonth() {
    const today = new Date();
    return new Date((new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth() + 1, 0)).setUTCHours(23, 59, 59, 999)))
        .toISOString()
        .replace('.999Z', '');
}

export function firstDayThisMonth() {
    const today = new Date();
    return new Date((new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), 1)).setUTCHours(0, 0, 0, 0)))
        .toISOString()
        .replace('.000Z', '');
}

export function firstDayLastMonth() {
    const today = new Date();
    return new Date((new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth() - 1, 1)).setUTCHours(0, 0, 0, 0)))
        .toISOString()
        .replace('.000Z', '');
}

export function thisDay() {
    const today = new Date();
    return new Date((new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate())).setUTCHours(23, 59, 59, 999)))
        .toISOString()
        .replace('.999Z', '');
}
